<!-- <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-mood-sad w-7rem h-7rem text-700" width="24" height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
  <circle cx="12" cy="12" r="9"></circle>
  <line x1="9" y1="10" x2="9.01" y2="10"></line>
  <line x1="15" y1="10" x2="15.01" y2="10"></line>
  <path d="M9.5 15.25a3.5 3.5 0 0 1 5 0"></path>
</svg> -->
<div class="mb-7">
<div class="mt-2 mb-4">No result found</div>
<img src="/assets/img/empty-state-datagrid-img.svg" alt="No Result Found" /> 
</div>